import Axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { AUTH_ROUTES } from '../../routers/RouteConstants';
import { NEW_USER_TOKEN_VERIFY } from '../../config/rest_endpoints';
import CustomLoader from '../../components/common/loader';
import Logo from '../../components/common/Logo';
import './style.css';

const MfaList = () => {
  const history = useHistory();
  const location = useLocation();
  const { search } = location;
  const urlToken = search.replace('?t=', '');
  const [mfaList, setMfaList] = useState([]);
  const [isLoad, setIsLoad] = useState(false);

  useEffect(() => {
    getTokenVerification();
  }, []);

  const getTokenVerification = () => {
    setIsLoad(true);
    const headers = { Authorization: 'Bearer ' + urlToken };
    Axios.get(NEW_USER_TOKEN_VERIFY, { headers })
      .then(res => {
        if (res.status === 200) {
          let resp = res.data.response;
          console.log('res', res);
          setMfaList(resp.data.mfa_list);
          setIsLoad(false);
        }
      })
      .catch(err => {
        // const errorMessage = err.response.data.message
        console.log(`err`, err);
        setIsLoad(false);
      });
  };

  const redirectMfa = row => {
    history.push({
      pathname: `${AUTH_ROUTES.qrCodeAndPasswordSet}/${row.name}`,
      state: {
        data: row,
        token: urlToken,
      },
    });
  };

  const renderMfaList = () => {
    if (!mfaList.length) {
      return (
        <div className="col-12 mb-2">
          <button type="button" disabled className="btn btn-light btn-block btn-float m-0 border">
            No List Available
          </button>
        </div>
      );
    } else {
      return mfaList.map((row, idx) => {
        return (
          <div
            className="d-flex justify-content-between align-items-start mb-2 border-top p-3 gap-3"
            style={{ margin: '0 auto', gap: '5px' }}
            key={idx}
          >
            {/* <i className={`icon-google icon-2x`}></i>
             */}
            <picture className="app-logos  d-flex justify-content-between align-items-start">
              <img src={row?.logo_big} alt="Google Auth App" />
            </picture>
            <article className="d-flex flex-column align-items-start flex-1" style={{ gap: '5px' }}>
              <h3 className="text-left" style={{ fontWeight: '600', color: '#616161' }}>
                {row.name}
              </h3>
              <a href={row.iphone_link} target="_blank" className="fw-bold" rel="noreferrer">
                iPhone (App Store){' '}
                <span>
                  <i className="fa fa-link" aria-hidden="true"></i>
                </span>
              </a>
              <a href={row.android_link} target="_blank" className="fw-bold" rel="noreferrer">
                Android (Google Play Store){' '}
                <span>
                  <i className="fa fa-link" aria-hidden="true"></i>
                </span>
              </a>
            </article>
            <article>
              <button
                type="button"
                className="btn btn-warning m-0 text-white"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  // background: '#17a6a8'
                }}
                onClick={redirectMfa.bind(this, row)}
              >
                Next
                <span style={{ fontSize: '10px' }}>
                  <i className="fa fa-chevron-right" aria-hidden="true"></i>
                </span>
              </button>
            </article>
          </div>
        );
      });
    }
  };

  return (
    <section className="login-form-container">
      <article className="login-page">
        <picture className="site-logo">
          <Logo width={'450px'} height={'450px'} />
        </picture>
        <div className="login-form">
          {isLoad ? (
            <CustomLoader width="40" height="40" customstyles={{ marginTop: '5em' }} />
          ) : (
            <div className="">
              {mfaList?.length !== 0 && (
                <h2 className="text-section" style={{ color: '#616161' }}>
                  <span style={{ fontWeight: '600', fontSize: '60px', lineHeight: '55px' }}>1</span>
                  Install an Authenticator App and click next
                </h2>
              )}
              <article className="apps-list">{renderMfaList()}</article>
            </div>
          )}
        </div>
      </article>
    </section>
  );
};

export default MfaList;
